/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Text_To_Audio_UndoInputs */

const en_dialog_text_to_audio_undo = /** @type {(inputs: Dialog_Text_To_Audio_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undo`)
};

const es_dialog_text_to_audio_undo = /** @type {(inputs: Dialog_Text_To_Audio_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deshacer`)
};

/**
* | output |
* | --- |
* | "Undo" |
*
* @param {Dialog_Text_To_Audio_UndoInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_undo = /** @type {((inputs?: Dialog_Text_To_Audio_UndoInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_UndoInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_undo(inputs)
	return en_dialog_text_to_audio_undo(inputs)
});